import { render, staticRenderFns } from "./PerformanceAppraisalDetail.vue?vue&type=template&id=5acd0d44&"
import script from "./PerformanceAppraisalDetail.vue?vue&type=script&lang=ts&"
export * from "./PerformanceAppraisalDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports